import { render, staticRenderFns } from "./Selectors.vue?vue&type=template&id=ad2d8270"
import script from "./Selectors.vue?vue&type=script&lang=js"
export * from "./Selectors.vue?vue&type=script&lang=js"
import style0 from "./Selectors.vue?vue&type=style&index=0&id=ad2d8270&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports